var exports = {
  "bW": "Board__ov8VDw",
  "tJ": "ColumnHeaders__O1xers",
  "Sc": "Rows__ULanlu",
};

module.exports = exports;
